import React from "react"
import ReactDOM from "react-dom"
import { CookiesProvider } from "react-cookie"
import LoginState from "./components/loginState"

export default class LoginStateApplet {
  constructor() {
    this.init()
    return this
  }

  init() {
    const loginContainers = document.querySelectorAll("[data-login-state]")
    if (loginContainers) {
      loginContainers.forEach((loginContainer, index) => {
        const config = (loginContainer.dataset.loginState && JSON.parse(loginContainer.dataset.loginState)) || {}
        ReactDOM.render(
          <CookiesProvider>
            <LoginState key={index} config={config} />
          </CookiesProvider>,
          loginContainer,
        )
      })
    }
  }
}
//window.loginState = new LoginStateApplet()
